export default __webpack_public_path__ + "static/media/library-1.8eb082cd.jpg";